import React from 'react';
import {
  Menu,
  Plus,
} from 'lucide-react';
import { useSelector } from 'react-redux';
import UserAvatar from '../Common/UserAvatar';
import { getPlanDetails } from '../../utils/planUtils';

const Navbar = ({ activeView, setIsMobileOpen, onNewSearch }) => {
  const { user } = useSelector((state) => state.user);
  const { currentAnalysis } = useSelector((state) => state.analysis);
  const getTitle = () => {
    switch (activeView) {
      case 'dashboard': return 'Dashboard Overview';
      case 'search': return 'New Property Analysis';
      case 'list': return 'All Properties';
      case 'reports': return 'Analysis Reports';
      default: return 'Property Analysis';
    }
  };

  const getSubtitle = () => {
    if (activeView === 'search' && currentAnalysis?.data) {
      const city = currentAnalysis.data.city || "";
      const county = currentAnalysis.data.county || "";
      if (city && county) return `${city}, ${county} County`;
      if (city || county) return city || county;
    }
    return "Property Development Platform";
  };
  return (
    <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b border-slate-200 shadow-sm">
      <div className="flex justify-between items-center py-3">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => setIsMobileOpen(true)}
            className="lg:hidden p-2 text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-all"
          >
            <Menu className="w-6 h-6" />
          </button>
          <div>
            <h1 style={{ fontSize: 22, fontWeight: 800, background: "linear-gradient(to right, #0f172a, #334155)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", margin: 0, lineHeight: 1.2 }}>
              {getTitle()}
            </h1>
            <p className="text-sm text-slate-500 mt-0.5">{getSubtitle()}</p>
          </div>
        </div>

        <div className="flex items-center space-x-2 md:space-x-4 mr-4">
          {activeView !== 'search' && (
            <button
              onClick={onNewSearch}
              className="flex items-center space-x-2 px-4 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl font-medium hover:shadow-lg hover:shadow-indigo-500/30 transition-all duration-200"
            >
              <Plus className="w-4 h-4" />
              <span className="hidden sm:inline">New Analysis</span>
            </button>
          )}
          
          {/* User Profile Summary */}
          <div className="flex items-center ml-2 border-l border-slate-200 pl-4 gap-4">
            <div className="hidden md:flex flex-col items-end">
                <p className="text-xs font-black text-slate-900 leading-none">{user?.full_name || 'Verified Identity'}</p>
                <span className={`text-[8px] font-black uppercase tracking-widest px-1.5 py-0.5 rounded-md border mt-1 ${getPlanDetails(useSelector(state => state.payment).subscription?.plan?.name, useSelector(state => state.payment).subscription?.status).colors}`}>
                    {getPlanDetails(useSelector(state => state.payment).subscription?.plan?.name, useSelector(state => state.payment).subscription?.status).label}
                </span>
            </div>
            <UserAvatar 
              user={user} 
              size="md" 
              indicator={true}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;